var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { Checkbox } from "../controls/Checkbox";
import { STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, StackView } from "../StackView";
import { Icon, ICON_SIZES } from "../Icon";
import { Text, TEXT_SIZE, TEXT_VIEW } from "../Text";
import { INDENT, View, VIEW_CONTENT_MOD } from "../View";
import { NodeCollapsedIcon, NodeExpandedIcon } from './arrowIcons';
import { measureText } from "../helpers/measureText";
import { Tooltip, useTooltip } from "../Tooltip";
import deepEqual from 'fast-deep-equal';
import { Spinner } from "../Spinner";
import { StatusIcon } from "../StatusIcon";
import { FolderClosedIcon, FolderOpenedIcon } from "../icons";
import { NodeData } from "./nodeData";
import { STATUSES } from "../common/public";
var WIDTH_ARROW_ICON = 10;
var Root = styled(StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n    box-sizing: border-box;\n    width: 100%;\n    height: ", ";\n    white-space: nowrap;\n\n    background-color: ", ";\n\n        ", "\n\n            padding-left: ", ";\n"], ["\n    cursor: pointer;\n    box-sizing: border-box;\n    width: 100%;\n    height: ",
    ";\n    white-space: nowrap;\n\n    background-color: ",
    ";\n\n        ",
    "\n\n            padding-left: ",
    ";\n"])), function (_a) {
    var autoHeight = _a.autoHeight, isCheckable = _a.isCheckable, theme = _a.theme;
    return autoHeight ? 'auto' : isCheckable ? theme.spacing.xl : theme.spacing.l;
}, function (_a) {
    var highlight = _a.highlight, theme = _a.theme;
    return highlight ? theme.colorHighlightDark : 'transparent';
}, function (props) {
    return !props.disabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                &:hover {\n                    background-color: ", ";\n                }\n\n                &.active,\n                &.active:hover {\n                    background-color: ", ";\n                }\n            "], ["\n                &:hover {\n                    background-color: ", ";\n                }\n\n                &.active,\n                &.active:hover {\n                    background-color: ", ";\n                }\n            "])), function (_a) {
        var theme = _a.theme;
        return theme.colorHighlightLight;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colorHighlightDark;
    });
}, function (_a) {
    var theme = _a.theme, isTerminal = _a.isTerminal, depth = _a.depth;
    return depth * WIDTH_ARROW_ICON +
        (isTerminal ? WIDTH_ARROW_ICON + 2 * parseInt(theme.spacing.s, 10) : 0) + "px";
});
var ToggleView = styled(View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        width: calc(", "px + 2 * ", ");\n        height: ", ";\n    "], ["\n        width: calc(", "px + 2 * ", ");\n        height: ", ";\n    "])), WIDTH_ARROW_ICON, theme.spacing.s, theme.spacing.m);
});
var CheckboxWrapper = styled(View)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-right: ", ";\n"], ["\n    padding-right: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.s;
});
var NodeDescriptionWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex: 1 1 100%;\n    width: 0;\n    align-self: center;\n    overflow: hidden;\n\n    ", "\n"], ["\n    flex: 1 1 100%;\n    width: 0;\n    align-self: center;\n    overflow: hidden;\n\n    ",
    "\n"])), function (_a) {
    var hideIcon = _a.hideIcon, theme = _a.theme;
    return !hideIcon && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            padding-left: ", ";\n        "], ["\n            padding-left: ", ";\n        "])), theme.spacing.s);
});
var onMouseEnterHandlerDecorator = function (tooltipHandler, ref) {
    return function () {
        var _a = measureText(ref), originalWidth = _a.originalWidth, fullWidth = _a.fullWidth;
        if (fullWidth > originalWidth) {
            tooltipHandler();
        }
    };
};
var DefaultNodeDescription = function (_a) {
    var description = _a.description, disabled = _a.disabled, dataSelectorId = _a.dataSelectorId;
    var ref = useRef(null);
    return useTooltip({
        text: description,
        delayTimeout: 400,
        render: function (tooltip) { return (React.createElement(Text, __assign({}, tooltip, { "data-selector-id": dataSelectorId, ref: ref, size: TEXT_SIZE.m, view: disabled ? TEXT_VIEW.light : undefined, truncate: true, onMouseEnter: onMouseEnterHandlerDecorator(tooltip.onMouseEnter, ref) }), description)); }
    });
};
var SPINNER_SIZE = 16;
var TreeNode = /** @class */ (function (_super) {
    __extends(TreeNode, _super);
    function TreeNode(props) {
        return _super.call(this, props) || this;
    }
    TreeNode.prototype.shouldComponentUpdate = function (nextProps) {
        var _a = this.props, node = _a.node, restProps = __rest(_a, ["node"]);
        var nextNode = nextProps.node, restNextProps = __rest(nextProps, ["node"]);
        if (!NodeData.equal(node, nextNode)) {
            return true;
        }
        return !deepEqual(restProps, restNextProps);
    };
    TreeNode.prototype.render = function () {
        var _a;
        var _b = this.props, node = _b.node, selected = _b.selected, onActivateNode = _b.onActivateNode, depth = _b.depth, renderer = _b.renderer, autoHeight = _b.autoHeight, iconRenderer = _b.iconRenderer, hideIcon = _b.hideIcon, checkable = _b.checkable, checkableConfig = _b.checkableConfig, checked = _b.checked, onCheckedNode = _b.onCheckedNode, onContextMenu = _b.onContextMenu, disabled = _b.disabled, expanded = _b.expanded, onExpandNode = _b.onExpandNode, _c = _b.loading, loading = _c === void 0 ? false : _c, warning = _b.warning, rest = __rest(_b, ["node", "selected", "onActivateNode", "depth", "renderer", "autoHeight", "iconRenderer", "hideIcon", "checkable", "checkableConfig", "checked", "onCheckedNode", "onContextMenu", "disabled", "expanded", "onExpandNode", "loading", "warning"]);
        var isTerminal = node.isTerminal();
        var renderNodeDescription = function () {
            var _a;
            var description = (_a = renderer === null || renderer === void 0 ? void 0 : renderer(node)) !== null && _a !== void 0 ? _a : node.id;
            return (React.createElement(NodeDescriptionWrapper, { hideIcon: hideIcon, "data-selector-id": rest['data-selector-id'] + "-description" }, typeof description === 'string' ? (React.createElement(DefaultNodeDescription, { description: description, disabled: disabled, dataSelectorId: rest['data-selector-id'] + "-text" })) : (description)));
        };
        var defaultIcon = isTerminal ? (React.createElement(FolderClosedIcon, null)) : expanded ? (React.createElement(FolderOpenedIcon, null)) : (React.createElement(FolderClosedIcon, null));
        var isCheckable = typeof checkable === 'function' ? checkable(node) : checkable;
        var isNodeLoading = !disabled && loading && !warning;
        var hasWarning = !disabled && warning;
        return (React.createElement(Root, { disabled: disabled, highlight: checkableConfig.checkableHighlighting && checked, testId: rest['data-selector-id'] + "-node-wrapper", isTerminal: isTerminal, autoHeight: autoHeight, depth: depth, className: selected ? 'active' : '', isCheckable: isCheckable, onClick: function (e) {
                if (!disabled) {
                    onActivateNode(node);
                    if (isCheckable && checkableConfig.checkableNode) {
                        e.preventDefault();
                        onCheckedNode === null || onCheckedNode === void 0 ? void 0 : onCheckedNode(node);
                    }
                }
            }, onContextMenu: function (e) {
                if (!disabled && onContextMenu) {
                    e.preventDefault();
                    onActivateNode(node);
                    onContextMenu(node, e.nativeEvent);
                }
            }, direction: STACK_DIRECTION.row, distribution: STACK_DISTRIBUTION.lastFill, align: STACK_ALIGN.center },
            React.createElement(StackView, { direction: STACK_DIRECTION.row, align: STACK_ALIGN.start, distribution: STACK_DISTRIBUTION.lastFill },
                React.createElement(StackView, { direction: STACK_DIRECTION.row, align: STACK_ALIGN.center, distribution: STACK_DISTRIBUTION.lastFill },
                    !isTerminal && (React.createElement(ToggleView, { "data-selector-id": rest['data-selector-id'] + "-toggle", contentMod: VIEW_CONTENT_MOD.center, onClick: function (event) {
                            event.stopPropagation();
                            if (!disabled) {
                                onExpandNode(node);
                            }
                        }, collapsable: false }, expanded ? (React.createElement(NodeExpandedIcon, { "data-selector-id": rest['data-selector-id'] + "-expanded-icon", disabled: disabled })) : (React.createElement(NodeCollapsedIcon, { "data-selector-id": rest['data-selector-id'] + "-collapsed-icon", disabled: disabled })))),
                    isCheckable && (React.createElement(CheckboxWrapper, { collapsable: false },
                        React.createElement(Checkbox, { onClick: function (e) {
                                if (!checkableConfig.activateNodeOnCheck) {
                                    e.stopPropagation();
                                }
                            }, onKeyPress: function (e) {
                                if (!checkableConfig.activateNodeOnCheck) {
                                    e.stopPropagation();
                                }
                            }, onChange: function () {
                                onCheckedNode === null || onCheckedNode === void 0 ? void 0 : onCheckedNode(node);
                            }, checked: checked, disabled: !!disabled, "data-selector-id": rest['data-selector-id'] + "-checkbox" }))),
                    isNodeLoading && (React.createElement(View, { indentRight: INDENT.m, "data-selector-id": rest['data-selector-id'] + "-loading" },
                        React.createElement(Spinner, { size: SPINNER_SIZE }))),
                    hasWarning && (React.createElement(View, { indentRight: INDENT.m },
                        React.createElement(Tooltip, { text: warning, render: function (injectProps) { return (React.createElement(StatusIcon, __assign({}, injectProps, { size: ICON_SIZES.m, status: STATUSES.warning, "data-selector-id": rest['data-selector-id'] + "-warning" }))); } }))),
                    hideIcon ? null : (React.createElement(Icon, { src: (_a = iconRenderer === null || iconRenderer === void 0 ? void 0 : iconRenderer({
                            node: node,
                            collapsed: !expanded,
                            terminal: isTerminal,
                            defaultIcon: defaultIcon
                        })) !== null && _a !== void 0 ? _a : defaultIcon, size: ICON_SIZES.m, disabled: disabled, "data-selector-id": rest['data-selector-id'] + "-icon" }))),
                renderNodeDescription())));
    };
    return TreeNode;
}(React.Component));
export { TreeNode };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=TreeNode.js.map